export default __webpack_public_path__ + "static/media/rupay.38537337.png";